module.exports = __webpack_public_path__ + "static/Meen@2x.acade1d3.png";